
import { Facebook, Instagram, Youtube, Music } from "lucide-react";
import { useSiteSettings } from "@/hooks/useSiteSettings";

const SocialIcons = () => {
  const { data: settings, isLoading, error, dataUpdatedAt } = useSiteSettings();

  console.log("SocialIcons - Settings:", settings);
  console.log("SocialIcons - Loading:", isLoading);
  console.log("SocialIcons - Error:", error);
  console.log("SocialIcons - Data updated at:", new Date(dataUpdatedAt));

  // If settings are loading, don't render anything
  if (isLoading) {
    console.log("SocialIcons - Still loading, not rendering");
    return null;
  }

  // If there's an error or no settings, don't render
  if (error || !settings) {
    console.log("SocialIcons - No settings available or error occurred");
    return null;
  }

  // Build social links array based on available settings
  const socialLinks = [
    settings.social_youtube && {
      name: "YouTube",
      icon: Youtube,
      url: settings.social_youtube,
      color: "hover:text-red-400"
    },
    settings.social_instagram && {
      name: "Instagram", 
      icon: Instagram,
      url: settings.social_instagram,
      color: "hover:text-pink-400"
    },
    settings.social_facebook && {
      name: "Facebook",
      icon: Facebook, 
      url: settings.social_facebook,
      color: "hover:text-blue-400"
    },
    settings.social_tiktok && {
      name: "TikTok",
      icon: Music,
      url: settings.social_tiktok,
      color: "hover:text-purple-400"
    }
  ].filter(Boolean); // Remove null/undefined entries

  console.log("SocialIcons - Filtered social links:", socialLinks);

  // If no social links are configured, don't render anything
  if (socialLinks.length === 0) {
    console.log("SocialIcons - No social links configured");
    return null;
  }

  return (
    <div className="flex space-x-4" key={dataUpdatedAt}>
      {socialLinks.map((social) => (
        <a
          key={`${social.name}-${dataUpdatedAt}`}
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          className={`p-3 bg-white/20 rounded-full ${social.color} transition-all duration-300 hover:scale-110 hover:bg-white/30`}
          aria-label={`Follow us on ${social.name}`}
        >
          <social.icon className="h-6 w-6" />
        </a>
      ))}
    </div>
  );
};

export default SocialIcons;
